import { makeConsentProvider } from './_provider.js';

const CookieInformationProvider = makeConsentProvider({
  hasConsented: (type) => {
    if (typeof window === "undefined" || typeof window.CookieInformation === "undefined" || typeof window.CookieInformation.getConsentGivenFor !== "function") {
      return false;
    }
    switch (type) {
      case "cookies.necessary":
        return true;
      case "cookies.preferences":
        return window.CookieInformation.getConsentGivenFor(
          "cookie_cat_functional"
        ) === true;
      case "cookies.statistics":
        return window.CookieInformation.getConsentGivenFor(
          "cookie_cat_statistic"
        ) === true;
      case "cookies.marketing":
        return window.CookieInformation.getConsentGivenFor(
          "cookie_cat_marketing"
        ) === true;
    }
  },
  handleRequestConsent: () => {
    if (typeof window === "undefined" || typeof window.CookieInformation === "undefined" || typeof window.CookieInformation._restartBanner !== "function") {
      return;
    }
    window.CookieInformation._restartBanner();
  },
  subscribe: (callback) => {
    if (window.CookieInformationScriptLoaded) {
      callback();
    }
    const uniqueCallback = () => callback();
    window.addEventListener("CookieInformationConsentGiven", uniqueCallback);
    return () => {
      window.removeEventListener(
        "CookieInformationConsentGiven",
        uniqueCallback
      );
    };
  }
});

export { CookieInformationProvider };
//# sourceMappingURL=integration.cookie-information.js.map
